var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 7.05713C19.9999 3.56541 17.3136 0.734863 14 0.734863H6C2.68638 0.734863 0.00014196 3.56541 0 7.05713V15.4878C0.000169596 18.9795 2.6864 21.8101 6 21.8101H14C17.3136 21.8101 19.9998 18.9795 20 15.4878V7.05713ZM5 11.272C5.00024 8.36645 7.24265 6.00342 10 6.00342C12.7574 6.00342 14.9998 8.36645 15 11.272C15 14.1777 12.7575 16.5415 10 16.5415C7.2425 16.5415 5 14.1777 5 11.272ZM15 4.94971C15.0001 4.42289 15.5001 3.896 16 3.896C16.4999 3.896 16.9999 4.42289 17 4.94971C17 5.47659 16.5 6.00342 16 6.00342C15.5 6.00342 15 5.47659 15 4.94971ZM7 11.2724C7 9.52651 8.34315 8.11116 10 8.11116C11.6569 8.11116 13 9.52651 13 11.2724C13 13.0184 11.6569 14.4337 10 14.4337C8.34315 14.4337 7 13.0184 7 11.2724Z",
    fill: "#28527A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.5a84b7efc632635bdb0fc6c8d1199508.svg";
export { ForwardRef as ReactComponent };